import { isPlatformBrowser } from '@angular/common';
import {
    Component,
    EventEmitter,
    Inject,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    Output,
    PLATFORM_ID,
    SimpleChanges
} from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs/index';
import { CommonService } from 'src/app/shared/services/common.service';
import { IDmsConfig } from '../../interface/document.manager.interface';
import { DocumentManagerService } from '../../services/document-manager.service';
import { MyDrive, State } from '../document-list/document-list.component';

@Component({
    selector: 'app-document-tree-view',
    templateUrl: './document-tree-view.component.html',
    styleUrls: ['./document-tree-view.component.scss']
})
export class DocumentTreeViewComponent implements OnInit, OnChanges, OnDestroy {
    @Input() State: State;
    @Input() MyDrive: MyDrive;
    @Input() folderChange: boolean;
    @Input() dmsConfig: IDmsConfig;
    @Input() projectId: string;
    @Output() SelectEvent = new EventEmitter<any>();

    nodata: boolean;

    displayedColumns = [
        'icon',
        'name',
        'type',
        'size',
        'created',
        'createdBy',
        'action'
    ];
    constructor(
        private router: Router,
        private commonService: CommonService,
        private dmsService: DocumentManagerService,
        @Inject(PLATFORM_ID) private platformId: Object,
        private translateService: TranslateService,
        private snackBar: MatSnackBar
    ) {
        this.isPlatformBrowser = isPlatformBrowser(this.platformId);
    }
    private subscription: Subscription[] = [];
    newProjectId: string;
    isPlatformBrowser: boolean;
    treeList: Array<any> = [];
    activeId = '';

    ngOnInit(): void {
        this.getTreeDetails();
        this.newProjectId = this.projectId;
        
        this.subscription.push(
            this.dmsService.getChildFolders.subscribe({
                next: (item) => {
                    const breadcrumb = JSON.parse(
                        localStorage.getItem(
                            this.dmsConfig && this.dmsConfig.BreadcrumbName
                        )
                    );
                    this.dmsService
                        .GetFolderOnly(
                            item.item.ItemId,
                            this.dmsConfig.ModuleWorkspaceId,
                            '',
                            this.dmsConfig.viewArchivedDoc
                        )
                        .then((documents) => {
                            this.handleDocuments(item, documents, breadcrumb);
                        });
                }
            })
        );

        this.subscription.push(
            this.dmsService.redirectFolder.subscribe({
                next: (response) => {
                    this.dmsService.FolderEvent.next([
                        { ItemId: '', Name: 'My Documents' },
                        ...response
                    ]);
                }
            })
        );
    }

    private handleDocuments(folder, documents, breadcrumb): void {
        const newDocument = this.getProjectFolder(documents);
        const tempArr = this.fileNameSort(newDocument);

        folder.Children =
            tempArr &&
            tempArr.map((folder) => {
                const newFolder = {
                    item: folder,
                    Children: [],
                    isOpen: false,
                    isReady: true,
                    level: folder.level + 1
                };
                if (breadcrumb) {
                    breadcrumb.forEach((breadcrumb, i) => {
                        if (
                            breadcrumb.ItemId === folder.ItemId
                        ) {
                            newFolder.isOpen = true;
                        }
                    });
                }
                return newFolder;
            });
        folder.isReady = true;
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.projectId) {
            this.newProjectId = changes.projectId.currentValue;
            if (!changes.projectId.firstChange) {
                this.getTreeDetails();
                this.getCorrectFolderId();
            }
        }
        // if (changes.folderChange) {
        //     if(!changes.folderChange.firstChange){
        //         this.getTreeDetails();
        //         this.getCorrectFolderId();
        //     }
        // }
    }
    
    ngOnDestroy() {
        if (this.subscription && this.subscription.length) {
            this.subscription.forEach((sub) => {
                sub.unsubscribe();
            });
        }
    }

    getCorrectFolderId() {
        if (this.isPlatformBrowser) {
            let dmsBread =
                JSON.parse(
                    localStorage.getItem(
                        this.dmsConfig && this.dmsConfig.BreadcrumbName
                    )
                ) || [];
            if (dmsBread.length > 0) {
                if (dmsBread[dmsBread.length - 1].Type == 'SharedFolder') {
                    return dmsBread[dmsBread.length - 1]
                        .OriginalObjectArtifactId;
                } else if (
                    dmsBread[dmsBread.length - 1].Type == 'DriveFolder'
                ) {
                    return dmsBread[dmsBread.length - 1].ItemId;
                }
            }
        }
    }

    getTreeDetails() {
        this.dmsService
            .GetFolderOnly(
                null,
                this.dmsConfig.ModuleWorkspaceId,
                '',
                this.dmsConfig.viewArchivedDoc
            )
            .then((documents) => {
                let newDocument = this.getProjectFolder(documents);
                const folders = this.fileNameSort(newDocument);
                this.treeList =
                    folders &&
                    folders.map((item) => {
                        const newItem = {
                            item: item,
                            Children: [],
                            isOpen: false,
                            isReady: true,
                            level: 0
                        };

                        return newItem;
                    });
            });
    }
    getProjectFolder(documents) {
        let newDocument =
            documents.length &&
            documents.filter(
                (newDoc) => newDoc.OrganizationId === this.newProjectId
            );
        return newDocument;
    }
    fileNameSort(arr) {
        arr &&
            arr.sort((a, b) => {
                const x = a['Name'].toLowerCase();
                const y = b['Name'].toLowerCase();
                if (x < y) {
                    return -1;
                }
                if (x > y) {
                    return 1;
                }
                return 0;
            });
        return arr;
    }
    matSnackBarOpen(value, duration?: number) {
        let translateValue = this.translateService.instant(value);
        this.snackBar.open(translateValue, null, {
            duration: duration || 3000,
            verticalPosition: 'top',
            horizontalPosition: 'end',
            panelClass: 'custom-snackbar'
        });
    }
}
